export const SOURCING_EXTERNAL_COMPANY_SIZES = [
  {
    label: '1-10',
    value: '1_10'
  },
  {
    label: '11-50',
    value: '11_50'
  },

  {
    label: '51-200',
    value: '51_200'
  },

  {
    label: '201-500',
    value: '201_500'
  },
  {
    label: '501-1000',
    value: '501_1000'
  },
  {
    label: '1001-5000',
    value: '1001_5000'
  },
  {
    label: '5001-10000',
    value: '5001_10000'
  },
  {
    label: '10001+',
    value: '10001'
  }
] as const;
